import React from "react";
import iconRemove from "../../../img/icons/remove_red.png";
import { useState } from "react";
import ApiData from "../../../api/ApiData";
import { ButtonFunctional } from "../ButtonFunctional";
import { SiteModalToolbarBtn } from "../../company/SiteModalToolbarBtn";

export const RemoveBtnModal = ({ setClosed, toolbarV4 = false }) => {
  const [modal, setModal] = useState(false);
  const removeProduction = async () => {
    const res = await ApiData.removeProduction();
    if (res) {
      setModal(false);
      setClosed(false);
    }
  };
  if (modal) {
    return (
      <div className="modal_fix_container">
        <div className="modal_fix_info">
          <p>
            Вы уверены, что хотите удалить площадку{" "}
            {ApiData.company.this_production.name_production}
          </p>
          <div className="flx-sb">
            <ButtonFunctional onClick={removeProduction}>
              Удалить
            </ButtonFunctional>
            <ButtonFunctional onClick={() => setModal(false)}>
              Отмена
            </ButtonFunctional>
          </div>
        </div>
      </div>
    );
  } else if (toolbarV4) {
    return (
      <SiteModalToolbarBtn
        variant="delete"
        onClick={() => setModal(true)}
        title="Удалить площадку"
      />
    );
  } else {
    return (
      <img
        onClick={() => setModal(true)}
        className="icon-remove-component"
        src={iconRemove}
        alt=""
      />
    );
  }
};
